export * from './grid-demo.component';
